var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.touch)?_c('div',{staticClass:"circle",attrs:{"id":"circle"}},[_c('img',{style:('left:' + _vm.left + 'px;top:' + _vm.top + 'px'),attrs:{"src":require("../assets/img/btn.png")},on:{"touchstart":_vm.start}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }